import { render, staticRenderFns } from "./TradePicker.vue?vue&type=template&id=13a8ccc9&"
import script from "./TradePicker.vue?vue&type=script&lang=ts&"
export * from "./TradePicker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports